import useSWR from "swr";
import { fetcher } from "lib/actions/fetcher";
import { endpointsLayers } from "lib/actions/endpoints/endpointsLayers";
import {
  ProjectLayerModel,
  normaliseVersionPolicy,
} from "lib/types/layers/ProjectLayerModel";

function mapLayerFromResponse(r: ProjectLayerModel): ProjectLayerModel {
  const versionPolicy = normaliseVersionPolicy(r.versionPolicy);
  return {
    ...r,
    versionPolicy,
    constituentAssets: r.constituentAssets ?? [],
    renderAssets: (r.renderAssets ?? []).map((a) => ({
      ...a,
      contentUri: a.contentUri ?? a.vectorContentUri,
    })),
    searchesStateJson: r.searchesStateJson ?? null,
    createdOn: (r.createdOn && new Date(r.createdOn)) || null,
  };
}

export function useProjectLayers(projectId: number) {
  const {
    data: layers,
    isLoading,
    error: layersError,
    mutate,
  } = useSWR(
    projectId && endpointsLayers.projectLayersByProject(projectId),
    (url) =>
      fetcher<ProjectLayerModel[]>(url).then((data) =>
        data.map(mapLayerFromResponse),
      ),
  );

  return {
    layers,
    hasError: !!layersError || !projectId,
    isLoading: isLoading && !layers,
    mutate,
  };
}
